module.exports = __webpack_public_path__ + "img/activities-6.1b71043c.jpg";